import { type FC, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { useSportUrlParams } from '@mwl/core-lib';
import MoreIcon from '@public/assets/common/icons/more.svg';
import { Button } from '@/components/Button/Button';
import { ButtonIcon } from '@/components/ButtonIcon/ButtonIcon';
import { Tooltip } from '@/components/Tooltip/Tooltip';
import type { AdditionalModeFilterProps } from './AdditionalModeFilter.types';
import styles from './AdditionalModeFilter.module.scss';
const AdditionalModeFilter: FC<AdditionalModeFilterProps> = ({
  className
}) => {
  const {
    t
  } = useTranslation('sport');
  const [isShow, setIsShow] = useState(false);
  const {
    createStageLink,
    stage
  } = useSportUrlParams();
  const buttonClassName = cn(styles.button, {
    [styles.opened]: isShow,
    [styles.closed]: !isShow
  });
  const isActive = stage === 'OUTRIGHT';
  const onShow = () => {
    setIsShow(true);
  };
  const onHide = () => {
    setIsShow(false);
  };
  const additionalLinks = <div>
      <Button className={styles.additionalLinks} as="link" href={createStageLink('OUTRIGHT')} variant="text" uppercase={false}>
        {t('outright', 'Outrights')}
      </Button>
    </div>;
  return <Tooltip maxWidth="none" onShow={onShow} onHide={onHide} variant="arrow" placement="bottom-start" content={additionalLinks} offset={[0, 8]} className={styles.tooltip} classes={{
    content: styles.content
  }} data-sentry-element="Tooltip" data-sentry-component="AdditionalModeFilter" data-sentry-source-file="AdditionalModeFilter.tsx">
      <ButtonIcon className={cn(buttonClassName, className, {
      [styles.active]: isActive
    })} as="button" size="xs" aria-label="more" data-sentry-element="ButtonIcon" data-sentry-source-file="AdditionalModeFilter.tsx">
        <MoreIcon width={20} height={20} className={styles.icon} data-sentry-element="MoreIcon" data-sentry-source-file="AdditionalModeFilter.tsx" />
      </ButtonIcon>
    </Tooltip>;
};
export { AdditionalModeFilter };